import React, { useContext } from 'react';
import '../../assets/styles/ActionGroup.scss';
import { Box, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { GaintOFDOrdersContext } from '../../context';

export default function ActionGroup() {
    const { selected, onManifestGen, onExport } = useContext(GaintOFDOrdersContext);

    return (
        <Box className="action-group" sx={{justifyContent: 'flex-end'}}>
            <Box className="left-buttons">
                <Button variant="contained" className="green-btn" endIcon={<DownloadIcon />} onClick={onExport}>
                    Export
                </Button>
                <Button
                    variant="contained"
                    className={`green-btn ${!selected.length ? 'disabled-green-btn' : ''}`}
                    disabled={!selected.length}
                    startIcon={<DownloadIcon />}
                    onClick={() => onManifestGen()}
                >
                    Download Manifest
                </Button>
            </Box>
        </Box>
    );
}
